import React from "react";
import { Link } from "react-router-dom";
import { REACT_APP_URL } from "../../config";

const ExploreProduct = ({ rootCollection = [], title = "Explore All Products" }) => {

  return (
    <div className="row" style={{ marginTop: "30px", paddingRight: "0px" }}>
      <p
        style={{
          color: "#818181",
          textAlign: "center",
          letterSpacing: "2px",
        }}
      >
        All Products
      </p>
      <h2
        style={{ textAlign: "center", textTransform: "uppercase" }}
      >
        {title}
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
      >
        {rootCollection?.length > 0 &&
          rootCollection.slice(0, 6).map((collection) => (
            <div key={collection.url}>
              <Link
                to={`/collection/${collection.url}`}
                className="sub-channel-info"
              >
                <center>
                  <div
                    className="col-lg-12 exploreallproductsstyle"
                    style={{
                      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.10), rgba(0, 0, 0, 0.5)), url(${REACT_APP_URL}/images/collection/${collection?.CollectionImage[0]})`,
                    }}
                  ></div>
                  <p className="exploreallproductstyleheading exploreallproductstyleheadingColor">
                    {collection.title}
                  </p>
                </center>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ExploreProduct;
